import {MovieLayerBase} from 'common/src/modules/movie/movieLayers.types';
import simpleMovieValue from 'common/src/modules/movie/utils/simpleMovieValue';

function createLayerBase(): Omit<MovieLayerBase, 'ty' | 'i' | 'name'> {
  return {
    mappingId: Math.floor(Math.random() * 1e8),
    en: true,
    aEn: false,
    mb: false,
    s: 0,
    e: 30500,
    is3d: false,
    tmt: 0,
    w: 0,
    h: 0,
    tr: {
      p: simpleMovieValue([0, 0, 0]),
      an: simpleMovieValue([0, 0, 0]),
      s: simpleMovieValue([1, 1, 1]),
      rx: simpleMovieValue([0]),
      ry: simpleMovieValue([0]),
      rz: simpleMovieValue([0]),
      a: simpleMovieValue([1]),
    },
    eff: [],
    masks: [],
  };
}

export default createLayerBase;
